import { render, staticRenderFns } from "./CompCreate.vue?vue&type=template&id=c267e686&scoped=true&"
import script from "./CompCreate.vue?vue&type=script&lang=js&"
export * from "./CompCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c267e686",
  null
  
)

export default component.exports